<template>
  <div class="welcome">
    <h3>{{ user.nickname ? `${user.nickname},${timeText}` : timeText }}</h3>
    <p>{{ $t('welcome_speech') }}</p>
    <div class="answer">
      <div class="block i-answer" @click="contactService">
        <h4>{{ $t(isMC() ? 'feedback' : 'online_answer') }}</h4>
        <p>{{ $t(isMC() ? 'feedback_desc' : 'online_answer_desc') }}</p>
      </div>
      <div class="block i-line" @click="handleHotline">
        <!-- <div :href="phone" class="block i-line" @click="handleHotline"> -->
        <h4>{{ $t('hotline') }}</h4>
        <p>
          {{ $t('service_time') }}: {{ currentType.start }}-{{
            currentType.end
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import native, { isMC } from '@/utils'

const { NativeFuncs, callNativeAsyncFunc } = native
export default {
  data() {
    return {
      isCall: true,
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUserInfo',
    }),
    timeText() {
      const hour = new Date().getHours()
      if (hour < 5) {
        return i18n.t('midnight')
      }
      if (hour < 10) {
        return i18n.t('morning')
      }
      if (hour < 12) {
        return i18n.t('forenoon')
      }
      if (hour < 14) {
        return i18n.t('noon')
      }
      if (hour < 18) {
        return i18n.t('afternoon')
      }
      return i18n.t('night')
    },
    currentType() {
      const defaultType = {
        start: '9:00',
        end: isMC() ? '18:30' : '20:30',
        tel: isMC() ? '+352 20333233' : '0571-88615387',
      }

      return (
        {
          zh: defaultType,
        }[i18n.locale] || defaultType
      )
    },
  },
  methods: {
    isMC,
    contactService() {
      if (isMC()) {
        this.$router.push('/feedback')
      } else {
        callNativeAsyncFunc(NativeFuncs.NAVIGATION.CUSTOMER_SERVICE).then(
          () => {
            // 跳转客服页面
          }
        )
      }
    },
    handleHotline() {
      if (this.isCall) {
        this.isCall = false
        window.location.href = `tel:${this.currentType.tel}`
        setTimeout(() => {
          this.isCall = true
        }, 2000)
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../../style/func.scss';

.welcome {
  padding: px2rem(8px) px2rem(12px);
  background-color: #fff;

  h3 {
    font-size: px2rem(20px);
    margin: 0;
  }
  p {
    font-size: px2rem(14px);
    color: #878787;
    margin-top: 0;
    margin-bottom: px2rem(15px);
  }
  .answer {
    display: flex;
    justify-content: space-between;

    .i-answer {
      padding-left: px2rem(50px);
      padding-right: px2rem(8px);
      background-image: url(../../../assets/answer.png);
      background-position: px2rem(-2px) center;
    }
    .i-line {
      padding-left: px2rem(56px);
      background-image: url(../../../assets/hot-line.png);
      background-position: px2rem(2px) center;
    }

    .block {
      width: 50%;
      height: px2rem(68px);
      padding-right: px2rem(2px);
      color: #fff;
      background-size: 100% auto;
      background-repeat: no-repeat;
      box-sizing: border-box;

      h4 {
        margin-top: px2rem(12px);
        margin-bottom: px2rem(4px);
      }

      p {
        color: #fff;
        font-size: px2rem(11px);
        font-weight: 300;
        margin: 0;
      }

      span {
        display: block;
        font-size: px2rem(10px);
        font-weight: 100;
        margin-top: px2rem(-2px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help-center/components/Welcome.vue